<template>
  <div class="sm-live-reception">
    <div class="sm-live-reception__icon">
      <include-svg :name="'live-receptionist'" />
    </div>
    <div class="sm-live-reception__main">
      <div class="sm-live-reception__main-top">
        <div>
          <h4>SpherePhone Live Receptionist</h4>
          <p>This is the professional voice with a personal touch for when your customer calls; representing your company, your way.</p>
        </div>
        <p
          v-if="!currentPlan && cheapestPrice"
          class="sm-txt-strong sm-txt-nowrap"
        >From {{formatPrice(cheapestPrice)}} / month</p>
      </div>
      <template v-if="currentPlan">
        <live-receptionist-item
          :item="currentPlan"
          :isCurrent="true"
          :showSwitch="true"
          :canSwitch="!isCustomer && plans.length > 1"
          :showCalls="!isCustomer"
          @switch="openPopup('select-plan')"
          @cancel="$emit('cancel')"
        />
        <btn-block
          :type="'small'"
          :text="'Add another Live Answering recipient'"
          :icon="'icon-plus'"
          @click="openPopup('add-users')"
        />
        <manage-live-answering
          v-if="users.length"
          :list="users"
          @update="data => $emit('update-user', data)"
          @delete="id => $emit('delete-user', id)"
        />
      </template>
      <ul 
        v-else
        class="sm-live-reception__main-plans"
      >
        <li
          v-for="plan in plans"
          :key="plan.id"
        >
          <live-receptionist-item
            :item="plan"
            :showCalls="!isCustomer"
            @subscribe="handleSubscribe"
          />
        </li>
      </ul>
      <ul 
        v-if="isCustomer"
        class="sm-live-reception__main-features"
      >
        <li
          v-for="feature in liveFeatures"
          :key="feature.id"
        >
          <include-svg :name="feature.icon" />
          <span>{{feature.text}}</span>
        </li>
      </ul>
      <div class="sm-live-reception__main-support">
        <i class="sm-sys sm-live-reception__main-support-icon">
          <svg class="sm-svg-icon sm-svg-icon-support">
            <use xlink:href="#icon-support" width="100%" height="100%" />
          </svg>
        </i>
        <p class="sm-reg sm-live-reception__main-support-txt">
          Have any questions about SpherePhone Live Receptionist service?
          <a
            :href="`mailto:${provider.email}`"
            class="sm-link sm-link-blue"
          >Ask support</a>
        </p>
      </div>
    </div>

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      :size="popup.type == 'select-plan' ? 'xlarge' : 'large'"
      :class="'sm-live-reception__popup'"
      @close="popup.isOpen = false;"
    >
      <template slot="popupContent">
        <div
          v-if="popup.type == 'select-plan'"
          class="sm-live-reception__popup-plans"
        >
          <h4>SpherePhone Live Receptionist Plans & Pricing</h4>
          <ul class="sm-live-reception__main-plans">
            <li
              v-for="plan in plans"
              :key="plan.id"
            >
              <live-receptionist-item
                :item="plan"
                :isCurrent="currentPlan && currentPlan.id == plan.id"
                :showCalls="!isCustomer"
                :subscribeText="plan.price > currentPlan.price ? 'Upgrade' : 'Downgrade'"
                @subscribe="handleSubscribe"
              />
            </li>
          </ul>
        </div>
        <additional-live-answering
          v-else-if="popup.type == 'add-users'"
          @submit="handleAddUsers"
        />
      </template>
    </popup-block>
  </div>
</template>

<script>
import LiveReceptionistItem from '@/components/account/LiveReceptionistItem';
import {FormatPrice} from '@/utils/general-data';
import LiveFeatures from '@/settings/live-answering-features';
import ManageLiveAnswering from '@/components/account/ManageLiveAnswering';
import AdditionalLiveAnswering from '@/components/account/AdditionalLiveAnswering'
import { mapGetters } from 'vuex';
import Popup from '@/components/Popup';

export default {
  name: 'live-receptionist',
  components: {
    'live-receptionist-item': LiveReceptionistItem,
    'manage-live-answering': ManageLiveAnswering,
    'additional-live-answering': AdditionalLiveAnswering,
    'popup-block': Popup
  },
  props: {
    plans: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    currentPlan: {},
    isCustomer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      liveFeatures: LiveFeatures,
      popup: {
        isOpen: false,
        type: '' // values: select-plan, add-users
      }
    }
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    }),
    cheapestPrice() {
      if (!this.plans.length)
        return null;

      let res = this.plans[0].price;
      this.plans.forEach(item => {
        if (item.price < res)
          res = item.price;
      });

      return res;
    }
  },
  methods: {
    formatPrice: FormatPrice,
    openPopup(type) {
      this.popup = {
        type,
        isOpen: true
      }
    },
    handleSubscribe(item) {
      this.popup.isOpen = false;
      this.$emit('subscribe', item);
    },
    handleAddUsers(users) {
      this.popup.isOpen = false;
      this.$emit('add-users', users);
    }
  }
}
</script>

<style lang="scss">
@use '@/assets/scss/general/mixins.scss' as *;
@use '@/assets/scss/framework/scss-variables.scss' as *;
@use '@/assets/scss/components/account/_live-receptionist.scss';
</style>